// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--burgundy) 0%, var(--violet) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.auth-card {
  background: var(--white);
  border-radius: 20px;
  padding: 36px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}
.auth-header { display: flex; align-items: center; gap: 16px; margin-bottom: 28px; }
.auth-logo { cursor: pointer; }
.logo-main { font-family: var(--font-display); font-size: 28px; font-weight: 600; color: var(--burgundy); display: block; line-height: 1; }
.logo-sub { font-size: 11px; color: var(--gray); letter-spacing: 3px; text-transform: uppercase; }
.auth-tabs {
  display: flex;
  background: var(--beige);
  border-radius: 10px;
  padding: 4px;
  margin-bottom: 28px;
}
.auth-tabs button {
  flex: 1 1;
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--gray);
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}
.auth-tabs button.active { background: var(--white); color: var(--burgundy); font-weight: 600; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
.auth-form { display: flex; flex-direction: column; gap: 18px; }
.form-group { display: flex; flex-direction: column; gap: 6px; }
.form-group label { font-size: 12px; font-weight: 600; color: var(--gray); letter-spacing: 0.5px; text-transform: uppercase; }
.form-group input {
  border: 1.5px solid var(--light-gray);
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  color: var(--black);
  transition: border-color 0.2s;
  background: var(--cream);
  flex: 1 1;
}
.form-group input:focus { border-color: var(--burgundy); background: var(--white); }
.form-group input:disabled { opacity: 0.6; }

.pwd-wrap { position: relative; display: flex; }
.pwd-wrap input { padding-right: 44px; width: 100%; }
.eye-btn {
  position: absolute;
  right: 12px; top: 50%;
  transform: translateY(-50%);
  background: none; border: none;
  color: var(--gray); cursor: pointer;
}

.otp-row { display: flex; gap: 8px; }
.otp-btn {
  background: var(--gradient-primary);
  color: var(--white);
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  letter-spacing: 0.5px;
  transition: opacity 0.2s;
}
.otp-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.verified-badge {
  background: #E8F5E9;
  color: #2E7D32;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.auth-submit { padding: 14px; font-size: 14px; letter-spacing: 1px; width: 100%; margin-top: 4px; }
.auth-submit:disabled { opacity: 0.7; cursor: not-allowed; }

.auth-switch { text-align: center; font-size: 13px; color: var(--gray); }
.auth-switch button { color: var(--burgundy); font-weight: 600; cursor: pointer; font-size: 13px; text-decoration: underline; background: none; border: none; }

/* ---- Mobile (phones ~320-430px) ---- */
@media (max-width: 600px) {
  .auth-page { padding: 16px; }
  .auth-card { padding: 24px 20px; border-radius: 16px; }
  /* Keep the OTP input and button from overflowing on narrow screens */
  .otp-row { flex-wrap: wrap; }
  .otp-row input { min-width: 0; }
}

/* Forgot password link under the sign-in button */
.auth-forgot-link {
  text-align: right;
  margin-top: -6px;
  margin-bottom: 4px;
}
.auth-forgot-link button {
  background: none;
  border: none;
  color: var(--violet);
  font-size: 12px;
  cursor: pointer;
  padding: 0;
}
.auth-forgot-link button:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/AuthPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,uCAAuC;AACzC;AACA,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACnF,aAAa,eAAe,EAAE;AAC9B,aAAa,gCAAgC,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,cAAc,EAAE,cAAc,EAAE;AAC1I,YAAY,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;AACjG;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;AACA,2BAA2B,wBAAwB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,qCAAqC,EAAE;AACtI,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC/D,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/D,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AAC7H;EACE,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB,SAAO;AACT;AACA,0BAA0B,6BAA6B,EAAE,wBAAwB,EAAE;AACnF,6BAA6B,YAAY,EAAE;;AAE3C,YAAY,kBAAkB,EAAE,aAAa,EAAE;AAC/C,kBAAkB,mBAAmB,EAAE,WAAW,EAAE;AACpD;EACE,kBAAkB;EAClB,WAAW,EAAE,QAAQ;EACrB,2BAA2B;EAC3B,gBAAgB,EAAE,YAAY;EAC9B,kBAAkB,EAAE,eAAe;AACrC;;AAEA,WAAW,aAAa,EAAE,QAAQ,EAAE;AACpC;EACE,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA,oBAAoB,YAAY,EAAE,mBAAmB,EAAE;AACvD;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE;AAClG,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D,eAAe,kBAAkB,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACxE,sBAAsB,sBAAsB,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,YAAY,EAAE;;AAE9J,yCAAyC;AACzC;EACE,aAAa,aAAa,EAAE;EAC5B,aAAa,kBAAkB,EAAE,mBAAmB,EAAE;EACtD,qEAAqE;EACrE,WAAW,eAAe,EAAE;EAC5B,iBAAiB,YAAY,EAAE;AACjC;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".auth-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--burgundy) 0%, var(--violet) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n.auth-card {\n  background: var(--white);\n  border-radius: 20px;\n  padding: 36px;\n  width: 100%;\n  max-width: 440px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.3);\n}\n.auth-header { display: flex; align-items: center; gap: 16px; margin-bottom: 28px; }\n.auth-logo { cursor: pointer; }\n.logo-main { font-family: var(--font-display); font-size: 28px; font-weight: 600; color: var(--burgundy); display: block; line-height: 1; }\n.logo-sub { font-size: 11px; color: var(--gray); letter-spacing: 3px; text-transform: uppercase; }\n.auth-tabs {\n  display: flex;\n  background: var(--beige);\n  border-radius: 10px;\n  padding: 4px;\n  margin-bottom: 28px;\n}\n.auth-tabs button {\n  flex: 1;\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gray);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.auth-tabs button.active { background: var(--white); color: var(--burgundy); font-weight: 600; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }\n.auth-form { display: flex; flex-direction: column; gap: 18px; }\n.form-group { display: flex; flex-direction: column; gap: 6px; }\n.form-group label { font-size: 12px; font-weight: 600; color: var(--gray); letter-spacing: 0.5px; text-transform: uppercase; }\n.form-group input {\n  border: 1.5px solid var(--light-gray);\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: var(--black);\n  transition: border-color 0.2s;\n  background: var(--cream);\n  flex: 1;\n}\n.form-group input:focus { border-color: var(--burgundy); background: var(--white); }\n.form-group input:disabled { opacity: 0.6; }\n\n.pwd-wrap { position: relative; display: flex; }\n.pwd-wrap input { padding-right: 44px; width: 100%; }\n.eye-btn {\n  position: absolute;\n  right: 12px; top: 50%;\n  transform: translateY(-50%);\n  background: none; border: none;\n  color: var(--gray); cursor: pointer;\n}\n\n.otp-row { display: flex; gap: 8px; }\n.otp-btn {\n  background: var(--gradient-primary);\n  color: var(--white);\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  letter-spacing: 0.5px;\n  transition: opacity 0.2s;\n}\n.otp-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.verified-badge {\n  background: #E8F5E9;\n  color: #2E7D32;\n  border-radius: 8px;\n  padding: 12px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.auth-submit { padding: 14px; font-size: 14px; letter-spacing: 1px; width: 100%; margin-top: 4px; }\n.auth-submit:disabled { opacity: 0.7; cursor: not-allowed; }\n\n.auth-switch { text-align: center; font-size: 13px; color: var(--gray); }\n.auth-switch button { color: var(--burgundy); font-weight: 600; cursor: pointer; font-size: 13px; text-decoration: underline; background: none; border: none; }\n\n/* ---- Mobile (phones ~320-430px) ---- */\n@media (max-width: 600px) {\n  .auth-page { padding: 16px; }\n  .auth-card { padding: 24px 20px; border-radius: 16px; }\n  /* Keep the OTP input and button from overflowing on narrow screens */\n  .otp-row { flex-wrap: wrap; }\n  .otp-row input { min-width: 0; }\n}\n\n/* Forgot password link under the sign-in button */\n.auth-forgot-link {\n  text-align: right;\n  margin-top: -6px;\n  margin-bottom: 4px;\n}\n.auth-forgot-link button {\n  background: none;\n  border: none;\n  color: var(--violet);\n  font-size: 12px;\n  cursor: pointer;\n  padding: 0;\n}\n.auth-forgot-link button:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
